/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-use-before-define */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { bindActionCreators } from 'redux';
import {
  Button,
  Checkbox,
  Dropdown,
  Grid,
  Modal,
  Popup,
  Loader,
  Dimmer,
  Divider,
  Header,
  Icon
} from 'semantic-ui-react';
import shortid from 'short-id';
import _ from 'lodash';
import { toast } from 'react-toastify';

import generatePdfAsync from '../../../services/PDFManager';
import getFullNameOrUserName from '../../../utils/user';
import { formatMonth } from '../../../utils/format';
import * as AppActions from '../../../actions';
import * as presentationBuilderDB from '../../../database/PresentationBuilderDB';
import { getRawAdName } from '../../../utils/ad.common';
import { restructureCampaign } from '../../../utils/campaignRestructuring';
// import ModalEmail from '../ModalEmail'; // disabled for now
import ModalCoopEmail from '../ModalCoopEmail';
import ModalEmailDiffUsers from '../ModalEmailDiffUsers';
import ModalCoopSubmission from '../ModalCoopSubmission';
import ModalCoopSubmissionJLR from '../ModalCoopJLRSubmission';
import ModalCoopSubmissionHonda from '../ModalCoopHondaSubmission';
import ModalCoopSubmissionToyota from '../ModalCoopToyotaSubmission';
import ModalShareLink from './ModalShareLink';
import domains from '../../../containers/Domains';
import { getUsers } from '../../../services/UserManagementService';

class SharePresentationEmail extends Component {
  constructor() {
    super();
    const formatOptions = [
      { key: 'all', text: 'All', value: 'all' },
      { key: 'desktop', text: 'Desktop', value: 'desktop' },
      { key: 'mobile', text: 'Mobile', value: 'mobile' }
    ];

    const coopOptions = [
      { key: 'campaign', text: 'Campaign', value: 'Campaign' },
      { key: 'single-ad', text: 'Single Ad', value: 'Single Ad' },
      { key: 'lease-specials', text: 'Lease Specials', value: 'Lease Specials' }
    ];

    this.state = {
      shareLink: '',
      presentation: {
        data: {},
        url: ''
      },
      selectedWeeks: 7,
      emailTemplate: '',
      formats: ['DESKTOP_FEED_STANDARD', 'MOBILE_FEED_STANDARD'],
      currentFormat: 'all',
      currentCoopOption: 'Campaign',
      currentCoopEmail: '',
      modalEmailInput: 'ademhadrovic@gmail.com',
      forceGenerateSS: true,
      includePreviewLink: true,
      oneVideoFrameOnly: false,
      formatOptions,
      coopOptions,
      pdfSettingsOpen: false,
      OEM: 'OEM',
      OEMArr: [
        { key: 'VW', text: 'VW', value: 'VW' },
        { key: 'Jaguar', text: 'Jaguar', value: 'Jaguar' },
        { key: 'Audi', text: 'Audi', value: 'Audi' },
        { key: 'Subaru', text: 'Subaru', value: 'Subaru' }
      ],
      adsAndUrls: [],
      users: [],
      selectedUsers: [],
      usersLoading: false,
      expirationDropDownOpen: false,
      showFormatPanel: false,
      loadingSendPdf: false
    };
  }

  componentDidMount() {
    this.getEmailTemplate();
    this.fillWeeks();
    document.querySelector('.App-content').addEventListener('scroll', () => {
      if (this.state.pdfSettingsOpen) {
        this.setState({
          pdfSettingsOpen: false
        });
      }
    });
  }

  componentWillMount() {
    document.querySelector('.App-content').addEventListener('scroll', () => {
      if (this.state.pdfSettingsOpen) {
        this.setState({
          pdfSettingsOpen: false
        });
      }
    });
  }

  getUsers = async () => {
    this.setState(
      {
        ...this.state,
        usersLoading: true
      },
      () => {
        const userData = {
          requester: this.props.user.email.trim()
        };
        getUsers(userData).then((users) => {
          const validUsers = [];
          const { Users } = users.users;
          for (let i = 0; i < Users.length; i += 1) {
            if (Users[i].Username.includes('@constellationagency.com')) {
              const { Username } = Users[i];
              const userVal = {
                key: Username,
                text: Username,
                value: Username
              };
              validUsers.push(userVal);
            }
          }
          this.setState(
            {
              ...this.state,
              users: validUsers
            },
            () => {
              this.setState({
                ...this.state,
                usersLoading: false
              });
            }
          );
        });
      }
    );
  };

  renderUsersLoading = () => {
    const { usersLoading } = this.state;
    if (usersLoading) {
      return (
        <Dimmer active style={{ width: '100%', height: '336%' }}>
          <Loader content="Loading Users Please Wait" />
        </Dimmer>
      );
    }
    return null;
  };

  handleUserSelectChange = (event, data) => {
    const chosenOption = data;
    this.setState({ selectedUsers: chosenOption.value });
  };

  sendToUsers = () => {
    this.showSendUsersModal();
  };

  handleOEMChange = (e, data) => {
    const text = data.options.find((o) => o.value === data.value).text;
    const chosenOption = data;
    this.setState({
      OEM: text,
      [chosenOption.name]: chosenOption.value
    });
  };

  handleCoopButton = async () => {
    const noAdsSelected = this.checkIfSelectedAdsIsEmpty();
    if (noAdsSelected) {
      toast(
        'There are no selected ads. Click the Filter Ads button to select ads to share in the PDF.',
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        }
      );
    } else {
      const { OEM } = this.state;
      await this.cleanAdUrls();
      if (OEM === 'Audi' || OEM === 'Subaru SAF' || OEM === 'Subaru SDCAP') {
        this.showCoopEmailModal();
      } else if (OEM === 'VW' || OEM === 'CDJR') {
        this.showCoopEmailModalVWCDJR();
      } else if (OEM === 'Jaguar' || OEM === 'Land Rover') {
        this.showCoopEmailModalJaguar();
      } else if (OEM === 'Honda') {
        this.showCoopEmailModalHonda();
      } else if (OEM === 'Toyota') {
        this.showCoopEmailModalToyota();
      } else {
        toast('Please Select A OEM First Before Continuing', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
          type: toast.TYPE.WARNING
        });
      }
    }
  };

  cleanAdUrls = () => {
    const { selectedAds, adAccountUrls } = this.props;
    const accounts = [];
    const accountUrlsBeingUsed = [];
    const selectedAdsKeys = Object.keys(selectedAds);
    return new Promise((resolve) => {
      selectedAdsKeys.forEach((key) => {
        selectedAds[key].forEach((ad) => {
          accounts.push(ad.id);
        });
      });
      for (let i = 0; i < accounts.length; i += 1) {
        for (let j = 0; j < adAccountUrls.length; j += 1) {
          if (accounts[i] === adAccountUrls[j].ad_id) {
            accountUrlsBeingUsed.push(adAccountUrls[j]);
          }
        }
      }
      this.setState(
        {
          adsAndUrls: accountUrlsBeingUsed
        },
        () => {
          resolve();
        }
      );
    });
  };

  handlePopUpInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onCloseEmailModal = () => {
    this.setState({ showEmailModal: false });
  };

  onCloseCoopEmailModal = () => {
    this.setState({
      ...this.state,
      showCoopEmailModal: false,
      pdfSettingsOpen: true
    });
  };

  onCloseCoopVWCDJRModal = () => {
    this.setState({
      ...this.state,
      showCoopVWCDJREmailModal: false,
      pdfSettingsOpen: true
    });
  };

  onCloseCoopJaguarModal = () => {
    this.setState({
      ...this.state,
      showCoopJaguarEmailModal: false,
      pdfSettingsOpen: true
    });
  };

  onCloseCoopHondaModal = () => {
    this.setState({
      ...this.state,
      showCoopHondaEmailModal: false,
      pdfSettingsOpen: true
    });
  };

  onCloseCoopToyotaModal = () => {
    this.setState({
      ...this.state,
      showCoopToyotaEmailModal: false,
      pdfSettingsOpen: true
    });
  };

  onCloseSendUsersModal = () => {
    this.setState({
      ...this.state,
      showSendUsersModal: false,
      pdfSettingsOpen: true
    });
  };

  onWeekSelect = (event, data) => {
    this.setState({
      selectedWeeks: data.value
    });
  };

  onFormatChange = (event, data) => {
    const format = data.value;
    let formats = ['DESKTOP_FEED_STANDARD', 'MOBILE_FEED_STANDARD'];
    switch (format) {
      case 'desktop':
        formats = ['DESKTOP_FEED_STANDARD'];
        break;
      case 'mobile':
        formats = ['MOBILE_FEED_STANDARD'];
        break;
      case 'all':
        formats = ['DESKTOP_FEED_STANDARD', 'MOBILE_FEED_STANDARD'];
        break;
      default:
        formats = ['DESKTOP_FEED_STANDARD', 'MOBILE_FEED_STANDARD'];
        break;
    }

    this.setState({
      formats,
      currentFormat: format
    });
  };

  onCoopOptionChange = (event, data) => {
    const chosenOption = data;
    this.setState({ [chosenOption.name]: chosenOption.value });
  };

  getEmailTemplate = async () => {
    const client = window.__APOLLO_CLIENT__;
    const queryResult = await client.query({
      query: presentationBuilderDB.EmailTemplateByNameQuery,
      variables: { name: 'ShareLinkTemplate' }
    });
    if (
      queryResult.data.emailTemplate !== null &&
      queryResult.data.emailTemplate.nodes[0]
    ) {
      this.setState({
        emailTemplate: queryResult.data.emailTemplate.nodes[0].content
      });
    }
  };

  fillWeeks = () => {
    const weeks = [
      { key: 1, text: '1 week', value: 7 },
      { key: 2, text: '2 weeks', value: 14 },
      { key: 3, text: '3 weeks', value: 21 },
      { key: 4, text: '4 weeks', value: 28 },
      { key: 5, text: '3 months', value: 90 },
      { key: 6, text: '6 months', value: 180 }
    ];

    this.setState({
      weeksOptions: weeks
    });
  };

  showEmailModal = async () => {
    const noAdsSelected = this.checkIfSelectedAdsIsEmpty();
    if (noAdsSelected) {
      toast(
        'There are no selected ads. Click the Filter Ads button to select ads to share in the PDF.',
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        }
      );
    } else {
      await this.saveOrUpdatedPresentation();
      this.setState({ showEmailModal: true });
    }
  };

  showCoopEmailModal = async () => {
    await this.saveOrUpdatedPresentation();
    this.setState({ pdfSettingsOpen: false, showCoopEmailModal: true });
  };

  showCoopEmailModalVWCDJR = async () => {
    await this.saveOrUpdatedPresentation();
    this.setState({ pdfSettingsOpen: false, showCoopVWCDJREmailModal: true });
  };

  showCoopEmailModalJaguar = async () => {
    await this.saveOrUpdatedPresentation();
    this.setState({ pdfSettingsOpen: false, showCoopJaguarEmailModal: true });
  };

  showCoopEmailModalHonda = async () => {
    await this.saveOrUpdatedPresentation();
    this.setState({ pdfSettingsOpen: false, showCoopHondaEmailModal: true });
  };

  showCoopEmailModalToyota = async () => {
    await this.saveOrUpdatedPresentation();
    this.setState({ pdfSettingsOpen: false, showCoopToyotaEmailModal: true });
  };

  showSendUsersModal = async () => {
    try {
      const noAdsSelected = this.checkIfSelectedAdsIsEmpty();
      if (noAdsSelected) {
        toast(
          'There are no selected ads. Click the Filter Ads button to select ads to share in the PDF.',
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 4000,
            type: toast.TYPE.WARNING,
            hideProgressBar: true
          }
        );
      } else {
        await this.getUsers();
        await setTimeout(async () => {
          await this.saveOrUpdatedPresentation();
          await this.cleanAdUrls();
          this.setState({ pdfSettingsOpen: false, showSendUsersModal: true });
        }, 1500);
      }
    } catch (err) {
      console.log('Error', err);
      toast(
        'There was an error when retrieving the user list. Please try again.',
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        }
      );
    }
  };

  closeForm = () => {
    this.setState((prevState) => ({ ...prevState, showForm: false }));
  };

  customizeShareLink = () => {
    const { actions } = this.props;
    // await window.__APOLLO_CLIENT__.resetStore();
    actions.displayCustomCheckbox();
  };

  generateSharePreviewLInk = async (event) => {
    const noAdsSelected = this.checkIfSelectedAdsIsEmpty();
    if (noAdsSelected) {
      toast(
        'There are no selected ads. Click the Filter Ads button to select ads to share in the PDF.',
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        }
      );
    } else {
      event.preventDefault();
      await this.saveOrUpdatedPresentation();
      this.setState((prevState) => ({ ...prevState, showForm: true }));
    }
  };

  saveOrUpdatedPresentation = async () => {
    const {
      selectedAds,
      showCheckboxes,
      campaignMonthName,
      adAccountName,
      selectedYear,
      user,
      selectedAccounts,
      campaign_ids: campaignIds,
      submit,
      update
    } = this.props;
    const { selectedWeeks } = this.state;
    const presentationData = {};
    presentationData.campaigns = {};
    const selectedAdKeys = Object.keys(selectedAds);
    selectedAdKeys.forEach((key) => {
      presentationData.campaigns[key] = [];
    });

    const presentationTitleCustom = showCheckboxes ? 'CUSTOM - ' : '';
    const formatMonthText = formatMonth(campaignMonthName);
    presentationData.title = `${presentationTitleCustom}${adAccountName} - ${formatMonthText} ${selectedYear}`;
    const presentation = this.state.presentation;

    // if presentation already exists (unique name is set) don't update the share link!
    presentation.url = `${shortid.generate()}${shortid.generate()}${shortid.generate()}`;
    presentation.data = JSON.stringify(presentationData);
    presentation.username = user.email;
    presentation.active = true;
    const ads = {};
    selectedAdKeys.forEach((k) => {
      ads[k] = selectedAds[k].map((a) => {
        const adName = getRawAdName(a.name);
        return {
          id: a.id,
          name: adName
        };
      });
    });
    presentation.cachedquery = JSON.stringify({
      account_id: selectedAccounts,
      month_year: campaignMonthName,
      campaign_ids: campaignIds,
      ads_ids: ads,
      is_multiple_accounts: false,
      is_custom_ads: showCheckboxes
    });
    const expirationDate = new Date();
    const days = selectedWeeks;
    expirationDate.setDate(expirationDate.getDate() + days);
    presentation.createdAt = new Date();
    presentation.updatedAt = new Date();
    presentation.expiredAt = expirationDate.toISOString().split('T')[0];
    const presentationCustomName = showCheckboxes
      ? `CUSTOM - ${new Date().getTime()} `
      : '';
    presentation.name = `${presentationCustomName}${adAccountName} ${campaignMonthName} ${selectedYear}`;

    this.setState({ presentation });
    try {
      await submit(presentation);
      this.setState({
        presentationSaved: 'new',
        shareLink: presentation.url
      });
    } catch (error) {
      // failed to save? do we have a collison in the name field?
      const updatedPresentation = await update(presentation);
      this.setState({
        presentationSaved: 'update',
        shareLink:
          updatedPresentation.data.updatePresentationByName.presentation.url
      });
    }
  };

  isCarouselAd = (creative) =>
    creative &&
    creative.link_data &&
    creative.link_data.child_attachments &&
    creative.link_data.child_attachments.length > 0;

  isCanvasAd = (creative) => {
    if (!creative) return false;
    const allLinks = [];
    let isCanvas = false;
    let l = '';
    if (
      creative &&
      creative.link_data &&
      creative.link_data.child_attachments
    ) {
      creative.link_data.child_attachments.forEach((li) =>
        allLinks.push(li.link)
      );
    }
    if (
      creative.video_data &&
      creative.video_data.call_to_action &&
      creative.video_data.call_to_action &&
      creative.video_data.call_to_action.value &&
      creative.video_data.call_to_action.value.link
    ) {
      l = creative.video_data.call_to_action.value.link;
      allLinks.push(l);
    }

    if (creative.call_to_action && creative.call_to_action.link) {
      l = creative.call_to_action.link;
      allLinks.push(l);
    }

    if (creative && creative.link_data && creative.link_data.link) {
      l = creative.link_data.link;
      allLinks.push(l);
    }

    if (creative.template_data && creative.template_data.link) {
      l = creative.template_data.link;
      allLinks.push(l);
    }

    if (
      creative &&
      creative.link_data &&
      creative.link_data.call_to_action &&
      creative.link_data.call_to_action.value &&
      creative.link_data.call_to_action.value.lead_gen_form_id
    ) {
      allLinks.splice(0, allLinks.length);
    }
    allLinks.forEach((li) => {
      if (li !== null) {
        if (li.split('canvas_doc').length > 1) {
          isCanvas = true;
        }
      }
    });
    return isCanvas;
  };

  mapSelectedAdsFromCampaignMonth = (campaignMonth, selectedAds) => {
    const selectedAdKeys = Object.keys(selectedAds);
    let finalSelectedAds = {};

    const wasCampaignMonthRestructured =
      selectedAdKeys.indexOf('MODEL_BASED') !== -1;

    if (!wasCampaignMonthRestructured) {
      const flattenedSelectedAds = [];
      selectedAdKeys.forEach((key) => {
        if (selectedAds[key] && selectedAds[key].length > 0) {
          selectedAds[key].forEach((ad) => {
            flattenedSelectedAds.push(ad);
          });
        }
      });
      const { campaignMonth: restructuredCampaignMonth } =
        restructureCampaign(campaignMonth) || {};
      const campaignKeys = Object.keys(restructuredCampaignMonth);
      campaignKeys.forEach((key) => {
        const ads = [];
        flattenedSelectedAds.forEach((selectedAd) => {
          const foundAd = restructuredCampaignMonth[key].find(
            (ad) => selectedAd.id === ad.ad_id
          );
          if (foundAd) {
            ads.push(selectedAd);
          }
        });
        finalSelectedAds[key] = ads;
      });
    } else {
      finalSelectedAds = selectedAds;
    }

    return finalSelectedAds;
  };

  // function for sending PDFs to user and CO-OPs
  sharePDF = async (dataParameters) => {
    const {
      // getFilledAdsFromTabCampaigns,
      campaignMonth,
      selectedAds
    } = this.props;
    const {
      forceGenerateSS,
      formats,
      currentFormat,
      includePreviewLink,
      currentCoopOption,
      adsAndUrls,
      oneVideoFrameOnly,
      pdfSettingsOpen
    } = this.state;

    if (pdfSettingsOpen) {
      this.setState((prevState) => ({
        ...prevState,
        pdfSettingsOpen: false
      }));
    }

    try {
      const ads = [];
      const selectedAdsToUse = this.mapSelectedAdsFromCampaignMonth(
        campaignMonth,
        selectedAds
      );

      // this gets ad preview urls for each ad.
      // this is used for setting the Preview Links in PDFs to Iframe links of ad previews.
      // may need this to revert PDF preview link changes.
      // const adsWithFieldsAdded = await getFilledAdsFromTabCampaigns(
      //   selectedAdsToUse
      // );

      await this.saveOrUpdatedPresentation();

      const selectedAdKeys = Object.keys(selectedAdsToUse);
      selectedAdKeys.forEach((k) => {
        const fullShareLink = this.returnFullShareLink(this.state.shareLink);

        selectedAdsToUse[k].forEach((a, index) => {
          const { creative: adCreative, name, id } = a;
          const { object_story_spec: objectStorySpec } = adCreative || {};
          const creative =
            adCreative && objectStorySpec ? objectStorySpec : adCreative;
          const adName = getRawAdName(name);

          const isCarousel = this.isCarouselAd(creative);
          const isCanvas = this.isCanvasAd(creative);
          const isCollection = adName.split('Collection').length > 1;

          const {
            video_data: videoData,
            link_data: linkData,
            template_data: templateData
          } = creative || {};

          const isVideo =
            creative && typeof videoData !== 'undefined' && videoData !== null;
          const onlyMobile = isCollection || isCanvas;

          const desktopUrlVar = `${fullShareLink}#category=${k.toLowerCase()}&index=${index}&format=desktop`;
          const mobileUrlVar = `${fullShareLink}#category=${k.toLowerCase()}&index=${index}&format=mobile`;

          let ad = {};
          let currAdMessage = {};
          if (videoData) {
            const { message } = videoData;
            currAdMessage = message;
          } else if (linkData) {
            const { message } = linkData;
            currAdMessage = message;
          } else if (templateData) {
            const { message } = templateData;
            currAdMessage = message;
          }
          if (currentFormat === 'desktop') {
            if (!onlyMobile) {
              ad = {
                fullAdName: name,
                adId: id,
                ad_name: adName,
                ad_objective: k,
                accountId: this.props.selectedAccounts[0].value,
                formats,
                carouselLength: isCarousel
                  ? creative.link_data.child_attachments.length
                  : 0,
                isCarousel,
                isVideo,
                forceSS: forceGenerateSS,
                currAdMessage
              };
              if (includePreviewLink) {
                ad = {
                  ...ad,
                  desktopUrl: desktopUrlVar,
                  mobileUrl: mobileUrlVar
                };
              }
              ads.push(ad);
            }
          } else if (onlyMobile) {
            ad = {
              fullAdName: name,
              adId: a.id,
              ad_name: adName,
              ad_objective: k,
              accountId: this.props.selectedAccounts[0].value,
              formats: ['MOBILE_FEED_STANDARD'],
              carouselLength: isCarousel
                ? creative.link_data.child_attachments.length
                : 0,
              isCarousel,
              isVideo,
              forceSS: forceGenerateSS,
              currAdMessage
            };
            if (includePreviewLink) {
              ad = {
                ...ad,
                desktopUrl: desktopUrlVar,
                mobileUrl: mobileUrlVar
              };
            }
            ads.push(ad);
          } else {
            ad = {
              fullAdName: name,
              adId: a.id,
              ad_name: adName,
              ad_objective: k,
              accountId: this.props.selectedAccounts[0].value,
              formats,
              carouselLength: isCarousel
                ? creative.link_data.child_attachments.length
                : 0,
              isCarousel,
              isVideo,
              forceSS: forceGenerateSS,
              currAdMessage
            };
            if (includePreviewLink) {
              ad = {
                ...ad,
                desktopUrl: desktopUrlVar,
                mobileUrl: mobileUrlVar
              };
            }
            ads.push(ad);
          }
        });
      });

      const fullname = getFullNameOrUserName(this.props.user);
      let currFrames = [25, 50, 75, 95];
      if (oneVideoFrameOnly) {
        currFrames = [0];
      }

      const {
        user,
        selectedAccounts,
        adAccountName,
        selectedYear,
        campaignMonthName,
        campaign_ids
      } = this.props || {
        user: '',
        selectedAccounts: [{ value: '' }],
        adAccountName: '',
        selectedYear: '',
        campaignMonthName: ''
      };
      const { email } = user;

      const sender = dataParameters.coopVar || email;
      const recipient = dataParameters.recipient || email;
      const dataParametersToPass = { ...dataParameters };
      delete dataParametersToPass.coopVar;
      delete dataParametersToPass.recipient;

      const campaignIds = campaign_ids[0].value || [];
      let pdfType = 'presentation pdf';
      if (this.state.reimbursementPDF) {
        pdfType = 'reimbursement';
      }
      const data = {
        pdf_type: pdfType,
        campaignIds,
        recipient,
        sender,
        fullname,
        account_id: selectedAccounts[0].value,
        account_name: adAccountName,
        year: selectedYear,
        month: campaignMonthName,
        includePreviewLink,
        ads,
        frames: currFrames,
        processToken: shortid.generate(),
        email_template: currentCoopOption,
        selectedUrls: adsAndUrls,
        ...dataParametersToPass
      };

      const generatePdfResult = await generatePdfAsync(data).then(() => {
        this.setState({
          ...this.state,
          reimbursementPDF: false
        });
      });

      return Promise.resolve(generatePdfResult);
    } catch (error) {
      return { error };
    }
  };

  sharePDFWithToast = async () => {
    const noAdsSelected = this.checkIfSelectedAdsIsEmpty();
    if (noAdsSelected) {
      toast(
        'There are no selected ads. Click the Filter Ads button to select ads to share in the PDF.',
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        }
      );
    } else {
      this.setState({ ...this.state, loadingSendPdf: true }, async () => {
        await this.cleanAdUrls();
        const sharePdfResult = await this.sharePDF({});
        const { error } = sharePdfResult || {};
        console.log('error:', error);
        if (error) {
          toast(
            'Something went wrong while generating PDF. There were likely too many ads selected. Selected fewer ads and try again.',
            {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 6000,
              type: toast.TYPE.ERROR,
              hideProgressBar: true
            }
          );
        } else {
          toast('The PDF will be emailed shortly', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 3000,
            type: toast.TYPE.SUCCESS,
            hideProgressBar: true
          });
        }
        this.setState({ ...this.state, loadingSendPdf: false });
      });
    }
  };

  shareReimbursementPDFWithToast = async () => {
    const noAdsSelected = this.checkIfSelectedAdsIsEmpty();
    if (noAdsSelected) {
      toast(
        'There are no selected ads. Click the Filter Ads button to select ads to share in the PDF.',
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        }
      );
    } else {
      this.setState({ ...this.state, loadingSendPdf: true }, async () => {
        await this.cleanAdUrls();
        let sharePdfResult = {};
        this.setState(
          {
            ...this.state,
            reimbursementPDF: true
          },
          async () => {
            sharePdfResult = await this.sharePDF({});
          }
        );

        const { error } = sharePdfResult || {};
        console.log('error:', error);
        if (error) {
          toast(
            'Something went wrong while generating PDF. There were likely too many ads selected. Selected fewer ads and try again.',
            {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 6000,
              type: toast.TYPE.ERROR,
              hideProgressBar: true
            }
          );
        } else {
          toast('The Reimbursement PDF will be emailed shortly', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 3000,
            type: toast.TYPE.SUCCESS,
            hideProgressBar: true
          });
        }
        this.setState({ ...this.state, loadingSendPdf: false });
      });
    }
  };

  checkIfSelectedAdsIsEmpty = () => {
    const { selectedAds } = this.props;
    const campaignKeys = Object.keys(selectedAds);
    const numberOfCampaignKeys = campaignKeys.length;
    let numberOfEmptyArrays = 0;
    campaignKeys.forEach((key) => {
      if (selectedAds[key].length <= 0) {
        numberOfEmptyArrays = numberOfEmptyArrays + 1;
      }
    });
    return numberOfCampaignKeys === numberOfEmptyArrays;
  };

  togglePdfSettings = () => {
    const { pdfSettingsOpen } = this.state;
    this.setState({
      pdfSettingsOpen: !pdfSettingsOpen,
      OEM: 'OEM'
    });
  };

  toggleExpirationSetting = () => {
    const { expirationDropDownOpen } = this.state;
    this.setState({
      expirationDropDownOpen: !expirationDropDownOpen
    });
  };

  returnFullShareLink = (shareLink) => {
    let urlString =
      shareLink !== null
        ? (urlString = `${window.location.protocol}//${window.location.host}${window.location.pathname}/${shareLink}`)
        : '';
    urlString = urlString
      .replace('preview', 'presentations')
      .replace('list', 'detail');
    return urlString;
  };

  render() {
    const coopEmailOptions = domains.coopRecipientOptions;
    const {
      shareLink,
      formatOptions,
      pdfSettingsOpen,
      showForm,
      forceGenerateSS,
      includePreviewLink,
      oneVideoFrameOnly,
      coopOptions,
      showCoopEmailModal,
      showCoopVWCDJREmailModal,
      showCoopJaguarEmailModal,
      showCoopHondaEmailModal,
      showCoopToyotaEmailModal,
      showSendUsersModal,
      currentCoopOption,
      currentCoopEmail,
      weeksOptions,
      // The two state attributes are used in Email (Beta).
      // emailTemplate,
      // showEmailModal,
      OEM,
      users,
      expirationDropDownOpen,
      loadingSendPdf
    } = this.state;
    const {
      user,
      adAccountName,
      campaignMonthName,
      showAdsLoading,
      showCheckboxesMultiQc,
      showCheckboxes
      // The four properties below are used in Email (Beta)
      // campaignMonth,
      // selectedAds,
      // campaignMonthRestructured,
      // campaignFromUrl
    } = this.props;
    const fullname = getFullNameOrUserName(user);
    const urlString = this.returnFullShareLink(shareLink);

    const applyGuestFilter = ['NU'].includes(user.groups[0]);

    return (
      <div>
        <ModalShareLink
          urlString={urlString}
          showForm={showForm}
          closeForm={this.closeForm}
        />
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column stretched>
              <Button
                disabled={showAdsLoading || showCheckboxesMultiQc}
                className="custom-button"
                color="green"
                onClick={this.customizeShareLink}
              >
                Select Ads
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {showCheckboxes ? (
          <div>
            <Divider />
            <Grid>
              <Grid.Row>
                <Grid.Column stretched>
                  <Header as="h4" textAlign="center">
                    Choose a Share Format
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column stretched>
                  <Button.Group>
                    <Button
                      color="orange"
                      onClick={this.sharePDFWithToast}
                      loading={loadingSendPdf}
                    >
                      <Icon name="file pdf outline" /> Share PDF
                    </Button>
                    <Popup
                      on="click"
                      position="bottom right"
                      wide
                      open={pdfSettingsOpen}
                      trigger={
                        <Button onClick={this.togglePdfSettings}>...</Button>
                      }
                    >
                      <Popup.Header>
                        <div>
                          <Header as="h4" basic floated="left">
                            Share PDF
                          </Header>
                          <Button
                            floated="right"
                            compact
                            basic
                            color="red"
                            icon="close"
                            onClick={this.togglePdfSettings}
                          />
                        </div>
                      </Popup.Header>
                      <Divider hidden />
                      <Grid>
                        <Grid.Row>
                          <Grid.Column>
                            <label>PDF Format: </label>
                            <Dropdown
                              placeholder="PDF Formats"
                              selection
                              defaultValue="all"
                              options={formatOptions}
                              onChange={this.onFormatChange}
                            />
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column>
                            <Checkbox
                              toggle
                              checked={forceGenerateSS}
                              onChange={() => {
                                this.setState({
                                  forceGenerateSS: !forceGenerateSS
                                });
                              }}
                              label="Force Screenshots Generation"
                            />
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column>
                            <Checkbox
                              toggle
                              checked={includePreviewLink}
                              onChange={() => {
                                this.setState({
                                  includePreviewLink: !includePreviewLink
                                });
                              }}
                              label="Include Preview Link"
                            />
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column>
                            <Checkbox
                              toggle
                              checked={oneVideoFrameOnly}
                              onChange={() => {
                                this.setState({
                                  oneVideoFrameOnly: !oneVideoFrameOnly
                                });
                              }}
                              label="One Video Frame In PDF"
                            />
                          </Grid.Column>
                        </Grid.Row>
                        {!applyGuestFilter && (
                          <Grid.Row>
                            <Grid.Column>
                              <label>OEM: </label>
                              <Dropdown
                                search
                                selection
                                options={coopEmailOptions}
                                placeholder="OEM"
                                onChange={this.handleOEMChange}
                                name="currentCoopEmail"
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                        {!applyGuestFilter && (
                          <Grid.Row>
                            <Grid.Column>
                              <label>PDF Content: </label>
                              <Dropdown
                                placeholder="Campaign"
                                selection
                                defaultValue={'Campaign'}
                                options={coopOptions}
                                onChange={this.onCoopOptionChange}
                                name="currentCoopOption"
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                        <Grid.Row>
                          <Grid.Column>
                            {this.renderUsersLoading()}
                            {!applyGuestFilter && (
                              <Button
                                color="green"
                                size="small"
                                onClick={this.handleCoopButton}
                                content={`Continue With ${OEM}`}
                              />
                            )}
                          </Grid.Column>
                        </Grid.Row>
                        {!applyGuestFilter && (
                          <Grid.Row>
                            <Grid.Column>
                              <Button
                                color="blue"
                                size="small"
                                onClick={this.showSendUsersModal}
                                content={`Send To Alexia Users`}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                        {!applyGuestFilter && (
                          <Grid.Row>
                            <Grid.Column>
                              <Button
                                color="orange"
                                size="small"
                                onClick={this.shareReimbursementPDFWithToast}
                                content={`Generate Reimbursement PDF`}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                      </Grid>
                    </Popup>
                  </Button.Group>
                  <Modal
                    dimmer="inverted"
                    open={showCoopEmailModal}
                    onClose={this.onCloseCoopEmailModal}
                  >
                    <Modal.Header>Coop Email</Modal.Header>
                    <Modal.Content>
                      <ModalCoopEmail
                        coopAdAccount={adAccountName}
                        coopMonth={campaignMonthName}
                        coopTypeSelection={currentCoopOption}
                        userName={fullname}
                        user={user}
                        recipientEmail={currentCoopEmail}
                        closeCoopModal={this.onCloseCoopEmailModal}
                        sendPDF={this.sharePDF}
                      />
                    </Modal.Content>
                  </Modal>
                  <Modal
                    dimmer="inverted"
                    open={showCoopVWCDJREmailModal}
                    onClose={this.onCloseCoopVWCDJRModal}
                  >
                    <Modal.Header>Coop (VW/CDJR) Email</Modal.Header>
                    <Modal.Content>
                      <ModalCoopSubmission
                        coopAdAccount={adAccountName}
                        coopMonth={campaignMonthName}
                        coopTypeSelection={currentCoopOption}
                        userName={fullname}
                        user={user}
                        recipientEmail={currentCoopEmail}
                        closeCoopModal={this.onCloseCoopVWCDJRModal}
                        sendPDF={this.sharePDF}
                      />
                    </Modal.Content>
                  </Modal>
                  <Modal
                    dimmer="inverted"
                    open={showCoopJaguarEmailModal}
                    onClose={this.onCloseCoopJaguarModal}
                  >
                    <Modal.Header>
                      Coop (Jaguar or Land Rover) Email
                    </Modal.Header>
                    <Modal.Content>
                      <ModalCoopSubmissionJLR
                        coopAdAccount={adAccountName}
                        coopMonth={campaignMonthName}
                        coopTypeSelection={currentCoopOption}
                        userName={fullname}
                        user={user}
                        recipientEmail={currentCoopEmail}
                        closeCoopModal={this.onCloseCoopJaguarModal}
                        sendPDF={this.sharePDF}
                      />
                    </Modal.Content>
                  </Modal>
                  <Modal
                    dimmer="inverted"
                    open={showCoopHondaEmailModal}
                    onClose={this.onCloseCoopHondaModal}
                  >
                    <Modal.Header>Coop Honda Email</Modal.Header>
                    <Modal.Content>
                      <ModalCoopSubmissionHonda
                        coopAdAccount={adAccountName}
                        coopMonth={campaignMonthName}
                        coopTypeSelection={currentCoopOption}
                        userName={fullname}
                        user={user}
                        recipientEmail={currentCoopEmail}
                        closeCoopModal={this.onCloseCoopHondaModal}
                        sendPDF={this.sharePDF}
                      />
                    </Modal.Content>
                  </Modal>
                  <Modal
                    dimmer="inverted"
                    open={showCoopToyotaEmailModal}
                    onClose={this.onCloseCoopToyotaModal}
                  >
                    <Modal.Header>Coop Toyota Email</Modal.Header>
                    <Modal.Content>
                      <ModalCoopSubmissionToyota
                        coopAdAccount={adAccountName}
                        coopMonth={campaignMonthName}
                        coopTypeSelection={currentCoopOption}
                        userName={fullname}
                        user={user}
                        recipientEmail={currentCoopEmail}
                        closeCoopModal={this.onCloseCoopToyotaModal}
                        sendPDF={this.sharePDF}
                      />
                    </Modal.Content>
                  </Modal>
                  <Modal
                    dimmer="inverted"
                    open={showSendUsersModal}
                    onClose={this.onCloseSendUsersModal}
                  >
                    <Modal.Header>Send PDF To Other Users</Modal.Header>
                    <Modal.Content>
                      <ModalEmailDiffUsers
                        coopAdAccount={adAccountName}
                        coopMonth={campaignMonthName}
                        coopTypeSelection={currentCoopOption}
                        userName={fullname}
                        user={user}
                        closeCoopModal={this.onCloseSendUsersModal}
                        sendPDF={this.sharePDFWithToast}
                        users={users}
                      />
                    </Modal.Content>
                  </Modal>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column stretched>
                  <Button.Group>
                    <Button
                      color="blue"
                      onClick={this.generateSharePreviewLInk}
                    >
                      <Icon name="share square" /> Share Link
                    </Button>
                    <Popup
                      on="click"
                      position="bottom right"
                      wide
                      open={expirationDropDownOpen}
                      trigger={
                        <Button onClick={this.toggleExpirationSetting}>
                          ...
                        </Button>
                      }
                    >
                      <Popup.Header>
                        <div>
                          <Header as="h4" basic floated="left">
                            Set Expiration
                          </Header>
                          <Button
                            floated="right"
                            compact
                            basic
                            color="red"
                            icon="close"
                            onClick={this.toggleExpirationSetting}
                          />
                        </div>
                      </Popup.Header>

                      <div className="weeks-container">
                        <Divider hidden />
                        <div className="weeks-label">
                          <strong>Exp Time</strong>
                        </div>
                        <div className="select-weeks">
                          <Dropdown
                            labeled
                            label={'Exp Time'}
                            placeholder="Expiration"
                            selection
                            defaultValue={7}
                            options={weeksOptions}
                            onChange={this.onWeekSelect}
                          />
                        </div>
                      </div>
                    </Popup>
                  </Button.Group>
                </Grid.Column>
              </Grid.Row>
              {/* <Grid.Row>
                <Grid.Column stretched>
                  <Button color="blue" onClick={this.showEmailModal}>
                    <Icon name="mail outline" /> Email (Beta)
                  </Button>
                  <Modal
                    dimmer="inverted"
                    open={showEmailModal}
                    onClose={this.onCloseEmailModal}
                  >
                    <Modal.Header>Email</Modal.Header>
                    <Modal.Content>
                      <ModalEmail
                        originalAds={campaignMonth}
                        selectedAds={selectedAds}
                        closeModal={this.onCloseEmailModal}
                        emailTemplate={emailTemplate}
                        shareLink={urlString}
                        month={campaignMonthName}
                        user={user}
                        restructuredAds={campaignMonthRestructured}
                        campaignFromUrl={campaignFromUrl}
                      />
                    </Modal.Content>
                  </Modal>
                </Grid.Column>
              </Grid.Row> */}
            </Grid>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  showCheckboxes: state.adPreview.showCheckboxes,
  showCheckboxesMultiQc: state.adPreview.showCheckboxesMultiQc,
  checkedCampaigns: state.adPreview.checkedCampaigns,
  selectedAds: state.adPreview.selectedAds
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const SharePresentationEmailWithData = compose(
  graphql(presentationBuilderDB.updateQuery, {
    props: ({ mutate }) => ({
      update: (presentation) =>
        mutate({
          variables: {
            name: presentation.name,
            presentation: _.omit(presentation, [
              'id',
              'url',
              'createdAt',
              'name',
              '__typename'
            ])
          },
          updateQueries: {
            getPresentations: (prev, { mutationResult }) => {
              const newPresentation =
                mutationResult.data.updatePresentationByName;
              return newPresentation;
            }
          }
        })
    })
  }),
  graphql(presentationBuilderDB.deleteQuery, {
    props: ({ mutate }) => ({
      delete: (id) => mutate({ variables: { id } })
    })
  }),
  graphql(presentationBuilderDB.submitRepository, {
    props: ({ mutate }) => ({
      submit: (presentation) => mutate({ variables: { presentation } })
    })
  })
)(SharePresentationEmail);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SharePresentationEmailWithData);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/SharePresentationEmail.js